import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { i18n, useGeneralSoContext, useGetFileById, useGetTermsAndConditions } from "src/common";
import { ContainerComponent, Loader } from "src/components";
import TermsCard from "src/components/cards/termsCard";



export interface TermsAndConditionsSectionInterface {
  sectionTitle?: string;
  sectionContent?: Array<{ text?: string, action?: () => void }>
}

const TermsAndConditionsPage = () => {
  const { offerId: offerIdFromUrl } = useParams();
  const { setOfferId, offerId } = useGeneralSoContext();
  const { loading: downloadFileLoading } = useGetFileById();
  const { termsAndConditions, loading } = useGetTermsAndConditions();

  useEffect(() => {
    if (offerIdFromUrl) {
      setOfferId(offerIdFromUrl);
    }
  }, [offerIdFromUrl]);


  return (
    <>
      <Helmet>
        <title>{i18n.t('pages.termsAndConditionsPage.title')} | kompare.hr</title>
      </Helmet>
      <ContainerComponent>
        {!offerId || loading || !termsAndConditions ? null : (
          <TermsCard termsAndConditions={termsAndConditions} />
        )}
      </ContainerComponent>
      {downloadFileLoading && <Loader overlay={true} />}
    </>
  );
};

export default TermsAndConditionsPage;